import overlay from "./overlay";

interface IModalConfig {
  nodeLists: IModalNodeLists,
  selectors: IModalSelectors
}

interface IModalNodeLists {
  modals: NodeList,
  open: NodeList,
  close: NodeList
}

interface IModalSelectors {
  modal: string,
  open: string,
  close: string
}

class Modal {

  private config: IModalConfig;

  constructor() {
    this.config = {
      nodeLists: {
        modals: null,
        open: null,
        close: null
      },
      selectors: {
        modal: '[data-modal]',
        open: '[data-modal-open]',
        close: '[data-modal-close]'
      }
    }
  }

  init() {
    this.config.nodeLists.modals = document.querySelectorAll(this.config.selectors.modal);
    this.config.nodeLists.open = document.querySelectorAll(this.config.selectors.open);
    this.config.nodeLists.close = document.querySelectorAll(this.config.selectors.close);
    this.addEventListeners();
  }

  addEventListeners() {
    this.config.nodeLists.open.forEach((htmlElement: HTMLElement) => htmlElement.addEventListener('click', this.handleClick.bind(this, htmlElement)));
    this.config.nodeLists.close.forEach((htmlElement: HTMLElement) => htmlElement.addEventListener('click', this.close.bind(this, htmlElement)));
  }

  handleClick(htmlElement: HTMLElement) {
    const key = htmlElement.dataset.key;
    if (key) this.open(key);
  }

  open(key: string) {
    const activeModal = this.getActiveModal(key);
    activeModal.classList.add('modal--active');
    const html:HTMLElement = document.body.parentNode as HTMLElement;
    html.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
    overlay.on();
  }

  close(htmlElement: HTMLElement) {
    htmlElement.closest(this.config.selectors.modal).classList.remove('modal--active');
    const html:HTMLElement = document.body.parentNode as HTMLElement;
    html.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
    overlay.off();
  }

  getActiveModal(key: string) : HTMLElement {
    return Array.from(this.config.nodeLists.modals).find((htmlElement: HTMLElement) => htmlElement.dataset.key === key) as HTMLElement;
  }
}

export default new Modal();